<div class="modal-content">
  <div class="modal-body text-center">
    <button type="button" class="close pull-right" aria-label="Close" (click)="handleClick({ close: true })">
      <i class="fas fa-times"></i>
    </button>
    <h4 class="modal-title" jhiTranslate="modals.customerUserTypology.title"></h4>
  </div>
  <div class="modal-body text-left">
    <div class="row" *ngIf="loaded">
      <div class="col-12">
        <p class="lead" jhiTranslate="modals.customerUserTypology.subTitle"></p>
      </div>
      <div class="col-12">
        <jhi-bary-input-select
          [label]="'modals.customerUserTypology.paymentPeriodLabel' | translate"
          [control]="controls.paymentPeriod"
          [options]="typologyOptions"
        ></jhi-bary-input-select>
      </div>
      <div class="col-12">
        <jhi-bary-input-number
          [label]="'modals.customerUserTypology.paymentDelay' | translate"
          [control]="controls.paymentDelay"
          [keyTranslateMinError]="'components.inputs.errors.minVal'"
          *ngIf="type !== OFFLINE && controls.paymentPeriod.value !== CASH"
        ></jhi-bary-input-number>
      </div>
    </div>
  </div>

  <!--Footer-->
  <div class="modal-footer justify-content-center">
    <jhi-bary-button
      [outline]="true"
      color="primary"
      [label]="'modals.customerUserTypology.buttons.cancel' | translate"
      (clickEvent)="handleClick({ cancel: true })"
      class="mr-2"
    ></jhi-bary-button>
    <jhi-bary-button
      (clickEvent)="handleSubmit()"
      [label]="'modals.customerUserTypology.buttons.submit' | translate"
      data-id-cypress="confirm-update"
      color="primary"
    ></jhi-bary-button>
  </div>
</div>
